import { InlineError, SkeletonLines } from '../BrowserPrimitives';
import { PaneCloseButton } from '../PaneCloseButton';
import type { Restored } from '../useRestoredSelection';

interface PaneRestoreStateProps {
    restored: Restored<unknown>;
    label: string;
}

// The body while a selection from the URL is still being looked up, or failed to load.
export function PaneRestoreBody({ restored, label }: PaneRestoreStateProps) {
    if (restored.kind === 'failed') {
        return (
            <div className="px-5 py-5">
                <InlineError message={restored.message} onRetry={restored.retry} />
            </div>
        );
    }
    return (
        <div className="px-5 py-5" aria-busy="true">
            <span className="sr-only">{`Loading ${label}`}</span>
            <SkeletonLines />
        </div>
    );
}

// The whole pane before the record behind its identity bar is known.
export function PaneRestoreState(props: PaneRestoreStateProps) {
    return (
        <div className="flex h-full min-h-0 flex-col">
            <div className="flex h-[68px] shrink-0 items-center justify-end bg-white pl-5 pr-4">
                <PaneCloseButton />
            </div>
            <PaneRestoreBody {...props} />
        </div>
    );
}
